export class AuthorizationFlowConstants {
  public static readonly PasswordExpired = 'PasswordExpired';
  public static readonly SessionExpiration = 'SessionExpiration';
  public static readonly PasswordChangeRequired = 'PasswordChangeRequired';
  public static readonly ValidationOtpRequired = 'two_factor_authentication_required';
  public static readonly ValidationOtpInvalid = 'two_factor_authentication_invalid';

  public static readonly ExpiredPasswordStatuses = [
    AuthorizationFlowConstants.PasswordExpired,
    AuthorizationFlowConstants.PasswordChangeRequired
  ];
}
